import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { CalendarModule } from 'primeng/calendar';

interface IconWrapperProps extends FormlyFieldProps {
  icon: string;
}

@Component({
  selector: 'kon-field-icon-wrapper',
  standalone: true,
  imports: [CommonModule, FormlyModule, CalendarModule],
  template: `
    <span class="p-input-icon-right group">
      <i
        class="z-10 {{ props.icon }}"
        [ngClass]="{ 'group-hover:invisible': this.field.type === 'number' }"
      ></i>
      <ng-container #fieldComponent></ng-container>
    </span>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldIconWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<IconWrapperProps>
> {}
